import React from 'react'

export const LookerProofOfConcept: React.FC = () => {
  return (
    <div style={{ padding: '30px' }}>
      {/* <iframe src="https://equidate.looker.com/embed/looks/98?allow_login_screen=true" width="1200" height="800" /> */}

      <iframe
        src="https://equidate.looker.com/embed/explore/base/order?qid=nB3HXOZJ4PfGgXGjXXlrPG&origin_space=30&toggle=fil,pik&allow_login_screen=true"
        style={{ width: '100%', height: 'calc(100vh - 150px)' }}
        title={'look89'}
      />
    </div>
  )
}
